// hooks/useUserInfo.ts
import { useEffect, useState } from 'react';
import { getUserInfo } from '../services/userServicer';

export const useUserInfo = () => {
  const [userInfo, setUserInfo] = useState<{
    id: string;
    email: string;
    tenantId: string;
  } | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const info = await getUserInfo();
        setUserInfo(info);
      } catch (error) {
        console.error("Failed to fetch user info:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserInfo();
  }, []);

  return { userInfo, loading };
};